import { Flex, Icon, Spinner, Text } from '@chakra-ui/react';
import React from 'react';

import { IconArrowRight } from 'assets/icons';
import { ReactSelectAsyncPaginate } from 'components/ReactSelect';

interface ICompanyCodeBlockProps {
  companyCodeLabel: string;
  currentMap: string;
  earningCodeMapStatus: string;
  selectedEarningCodeData: any;
  placeholder: string;
  companyCode: string;
  onEarningCodeSelected: (value: any, type: string) => void;
  earningCodesLoadOptions: (search: any, _: any, { page }: any) => Promise<any>;
}

const CompanyCodeBlock: React.FC<ICompanyCodeBlockProps> = ({
  companyCodeLabel,
  currentMap,
  earningCodeMapStatus,
  onEarningCodeSelected,
  earningCodesLoadOptions,
  selectedEarningCodeData,
  placeholder,
  companyCode,
}) => {
  return (
    <Flex
      gap={{ base: '0', md: '3' }}
      alignItems="center"
      mb="4"
      width={{ base: '100%', lg: '570px' }}
      direction={{ base: 'column', md: 'row' }}
    >
      <Text
        background={{ base: 'transparent', md: 'primary.50' }}
        width="100%"
        height="100%"
        px={{ base: '1', md: '3' }}
        py={{ base: '1', md: '2' }}
        fontSize="sm"
      >
        {companyCodeLabel}
      </Text>
      <Flex alignItems="center" position="relative" flex={{ base: '0 0 100%', md: '0 0 300px' }} gap="2" width="100%">
        <Icon
          display={{ base: 'none', md: 'inline-block' }}
          as={IconArrowRight}
          sx={{ '& path': { fill: 'gray.600' } }}
          mr="2"
        />
        {earningCodeMapStatus === 'loading' && currentMap === companyCode && (
          <Flex
            width="100%"
            height="100%"
            position="absolute"
            zIndex={2}
            justifyContent="center"
            alignItems="center"
            background="rgba(255, 255, 255, 0.7)"
          >
            <Spinner size="xs" />
          </Flex>
        )}

        <ReactSelectAsyncPaginate
          loadOptions={earningCodesLoadOptions}
          value={selectedEarningCodeData?.payload[companyCode]}
          additional={{
            page: 1,
          }}
          onChange={(value: any) => {
            onEarningCodeSelected(value, companyCode);
          }}
          size="md"
          variant="filled"
          fontSize="sm"
          width="100%"
          debounceTimeout={300}
          menuPortalTarget={document.body}
          isSearchable
          placeholder={placeholder}
          getOptionLabel={(option: any) => option.codeDescription}
          getOptionValue={(option: any) => option.codeValue}
        />
      </Flex>
    </Flex>
  );
};

export default CompanyCodeBlock;
